import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { StyEditCustomCadrageGrid } from '../style';
import { getEditCustomCadrageColDefs } from './helper';
import TextFloatingFilter from 'ui/AgGridReact/TextFloatingFilter';
import { CadrageSummaryItemT, CadrageSummaryT } from '../type';
import EditableInputCellRenderer from './EditableInputCellRenderer';
import { BudgetBys } from 'business/constants';
import { GetRowIdParams } from 'ag-grid-community';
import { onRowClicked } from 'routes/BudgetModule/components/BudgetProposal/Resource/ExpenseIncome/Imputations/helpers/gridHelpers';

const EditCustomCadrageGrid = ({
    cadrageSummary,
    by,
    byChapter,
}: {
    cadrageSummary: CadrageSummaryT;
    by: BudgetBys;
    byChapter: boolean;
}): React.ReactElement => {
    const columns = getEditCustomCadrageColDefs(by, byChapter);
    return (
        <StyEditCustomCadrageGrid
            className="ag-theme-material"
            data-testid="e2e-edit-custom-cadrage-grid"
        >
            <AgGridReact
                columnDefs={columns}
                getRowId={({ data }: GetRowIdParams<CadrageSummaryItemT>) =>
                    data.resource.softwareId + data.chapter
                }
                rowData={cadrageSummary}
                defaultColDef={{
                    flex: 1,
                }}
                columnMenu="legacy"
                components={{
                    textFloatingFilter: TextFloatingFilter,
                    editableInputCellRenderer: EditableInputCellRenderer,
                }}
                suppressAnimationFrame
                suppressClickEdit
                stopEditingWhenCellsLoseFocus
                undoRedoCellEditing
                suppressAggFuncInHeader
                groupDisplayType="multipleColumns"
                autoGroupColumnDef={{
                    filter: 'agGroupColumnFilter',
                    floatingFilter: true,
                    suppressFloatingFilterButton: true,
                    cellRendererParams: {
                        suppressCount: true,
                    },
                }}
                onRowClicked={(params) => {
                    if (params.node.group) onRowClicked(params);
                }}
            />
        </StyEditCustomCadrageGrid>
    );
};

export default EditCustomCadrageGrid;
